import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';

const LogoSlider = (sliderNode) => {
  if (!sliderNode) return;

  EmblaCarousel(
    sliderNode,
    {
      loop: true,
      align: 'start',
      containScroll: false,
      dragFree: true,
    },
    [
      AutoScroll({
        speed: 1,
        startDelay: 0,
        stopOnInteraction: false,
        stopOnMouseEnter: true,
        stopOnFocusIn: true,
        playOnInit: true,
      }),
    ]
  );
};

export default LogoSlider;
